"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const vue3_compat_1 = require("@/client/vue3-compat");
const Card_vue_1 = require("@/client/components/card/Card.vue");
const CardName_1 = require("@/common/cards/CardName");
exports.default = (0, vue3_compat_1.defineComponent)({
    name: 'HelpStandardProjects',
    components: {
        Card: Card_vue_1.default,
    },
    methods: {
        getBasicStandardProjects: () => [
            CardName_1.CardName.SELL_PATENTS_STANDARD_PROJECT,
            CardName_1.CardName.POWER_PLANT_STANDARD_PROJECT,
            CardName_1.CardName.ASTEROID_STANDARD_PROJECT,
            CardName_1.CardName.AQUIFER_STANDARD_PROJECT,
            CardName_1.CardName.GREENERY_STANDARD_PROJECT,
            CardName_1.CardName.CITY_STANDARD_PROJECT,
        ],
        getExpansionStandardProjects: () => [
            CardName_1.CardName.AIR_SCRAPPING_STANDARD_PROJECT,
            CardName_1.CardName.BUILD_COLONY_STANDARD_PROJECT,
            CardName_1.CardName.BUFFER_GAS_STANDARD_PROJECT,
        ],
        getFanMadeStandardProjects: () => [
            CardName_1.CardName.AIR_SCRAPPING_STANDARD_PROJECT_VARIANT,
            CardName_1.CardName.MOON_HABITAT_STANDARD_PROJECT,
            CardName_1.CardName.MOON_MINE_STANDARD_PROJECT,
            CardName_1.CardName.MOON_ROAD_STANDARD_PROJECT,
            CardName_1.CardName.MOON_HABITAT_STANDARD_PROJECT_VARIANT_1,
            CardName_1.CardName.MOON_MINE_STANDARD_PROJECT_VARIANT_1,
            CardName_1.CardName.MOON_ROAD_STANDARD_PROJECT_VARIANT_1,
            CardName_1.CardName.MOON_HABITAT_STANDARD_PROJECT_VARIANT_2,
            CardName_1.CardName.MOON_MINE_STANDARD_PROJECT_VARIANT_2,
            CardName_1.CardName.MOON_ROAD_STANDARD_PROJECT_VARIANT_2,
            CardName_1.CardName.EXCAVATE_STANDARD_PROJECT,
            CardName_1.CardName.COLLUSION_STANDARD_PROJECT,
        ],
    },
});
